<template>
  <div class="marketingResourses">
    <div class="feil_menu">
      <div class="feil_menu_title">{{ treeTitle }}</div>
      <div class="feil_menu_item">
        <el-tree
          :data="feilListData"
          node-key="id"
          :props="defaultProps"
          @node-click="handleNodeClick"
          :default-expanded-keys="unfoldArr"
          accordion
          :highlight-current="true"
          ref="tree"
        >
        <span class="span-ellipsis" slot-scope="{ node, data }">
        <span :title="node.label">{{ node.label }}</span>
        </span>
        </el-tree>
      </div>
    </div>
    <div class="feil_main">
      <div class="feil_main_title">{{ this.mainTitle }}</div>
      <!-- <div class="feil_main_intr">

      </div> -->
      <div class="feil_main_item" v-if="fileMainItemData&&fileMainItemData.length>0">
        <ul class="feil_main_item_ul">
          <li
            v-for="val in this.fileMainItemData"
            :key="val.id"
            class="feil_main_item_li"
          >
            <div class="content" @click="downFeil(val.downName,val.fileType)">
              <div class="content_icon">
                <img
                  :src="fileImg.ppt"
                  alt="ppt"
                  v-if="val.fileType == 'pptx'"
                />
                <img
                  :src="fileImg.doc"
                  alt="doc"
                  v-else-if="val.fileType == 'doc'"
                />
                <img
                  :src="fileImg.pdf"
                  alt="pdf"
                  v-else-if="val.fileType == 'pdf'"
                />
                <svg-icon
                  icon-class="image"
                  v-else-if="val.fileType == 'jpg' || val.fileType == 'png'"
                />
                <svg-icon icon-class="XLS" v-else-if="val.fileType == 'xlsx'" />
                <svg-icon
                  icon-class="video"
                  v-else-if="val.fileType == 'video'"
                />
              </div>
              <div class="content_title">
                <p>{{ val.fileName }}</p>
                <!-- <a :href="processEnvUrl+val.fileUrl" target="_blank" :download="val.downName">{{ val.fileName }}</a> -->
              </div>
              <div class="content_down">
                <svg-icon icon-class="download" />
              </div>
            </div>
          </li>
        </ul>
      </div>
      <div class="feil_main_item" v-else>
        <div class="noDetail">
          <svg-icon icon-class="nodeta"/>
          <p>No Data</p>
        </div>
      </div>
      <el-pagination
        layout="prev, pager, next"
        :total="pagination.total"
        :page-size="pagination.pageSize"
        @current-change="handleCurrentChange"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { getCurrentHost } from '@/utils/index.js'
export default {
  name: "marketingResourses",
  data() {
    return {
      showId: 1,
      showItem: 1,
      mainTitle: "",
      treeTitle: "",
      unfoldArr: [],
      processEnvUrl: "",
      pagination: {
        page: 0,
        pageSize: 8,
        total: 0,
        data: [],
      },
      fileMainItemData: [],
      defaultProps: {
        children: "children",
        label: "label",
      },
      feilListData: [
        {
          label: "Security",
          id: 1,
          children: [
            {
              label: "Ransomware Solution",
              id: 2,
              second_id: 1,
              children: [
                { label: "EDM", three_id: 1, id: 3 },
                { label: "Brochure", three_id: 2 },
                { label: "Webinar", three_id: 3 },
              ],
            },
            {
              label: "Continuous Detection and Simplified Secops",
              second_id: 2,
              children: [
                { label: "EDM", three_id: 4 },
                { label: "Brochure", three_id: 5 },
                { label: "Webinar", three_id: 6 },
              ],
            },
            {
              label: "Secure Internet Access",
              second_id: 3,
              children: [
                { label: "EDM", three_id: 7 },
                { label: "Brochure", three_id: 8 },
                { label: "Webinar", three_id: 9 },
              ],
            },
            {
              label: "Secure SD-WAN",
              second_id: 4,
              children: [
                { label: "EDM", three_id: 10 },
                { label: "Brochure", three_id: 11 },
                { label: "Webinar", three_id: 12 },
              ],
            },
            {
              label: "WFH",
              second_id: 5,
              children: [
                { label: "EDM", three_id: 13 },
                { label: "Brochure", three_id: 14 },
                { label: "Webinar", three_id: 15 },
              ],
            },
            {
              label: "Anti-Proxy",
              second_id: 6,
              children: [
                { label: "EDM",  },
                { label: "Brochure",  },
                { label: "Webinar",  },
              ],
            },
          ],
        },
      ],
      feilIndexData: {
        1: [
          {
            id: 1,
            fileName:
              "[Sangfor Webinar] Unlocking New Business Opportunities with Sangfor Incident Response.pdf",
            fileUrl:
              "[Sangfor Webinar] Unlocking New Business Opportunities with Sangfor Incident Response.pdf",
            downName:
              "[Sangfor Webinar] Unlocking New Business Opportunities with Sangfor Incident Response.pdf",
            fileType: "pdf",
          },
          {
            id: 2,
            fileName:
              "[Sangfor Webinar] US Colonial Pipeline attack_ Everything you need to know.pdf",
            fileUrl:
              "[Sangfor Webinar] US Colonial Pipeline attack_ Everything you need to know.pdf",
            downName:
              "[Sangfor Webinar] US Colonial Pipeline attack_ Everything you need to know.pdf",
            fileType: "pdf",
          },
          {
            id: 3,
            fileName: "FREE Vulnerability Assessment Promotion Campaign_PC.pdf",
            fileUrl: "FREE Vulnerability Assessment Promotion Campaign_PC.pdf",
            downName: "FREE Vulnerability Assessment Promotion Campaign_PC.pdf",
            fileType: "pdf",
          },
          {
            id: 4,
            fileName: "Incident Response Promotion June 2020.pdf",
            fileUrl: "Incident Response Promotion June 2020.pdf",
            downName: "Incident Response Promotion June 2020.pdf",
            fileType: "pdf",
          },
          {
            id: 5,
            fileName: "let-sangfor-protect-you-against-ransomware.pdf",
            fileUrl: "let-sangfor-protect-you-against-ransomware.pdf",
            downName: "let-sangfor-protect-you-against-ransomware.pdf",
            fileType: "pdf",
          },
          {
            id: 6,
            fileName:
              "ngaf-8026-industry-leading-performance-with-advanced-malware-protection.pdf",
            fileUrl:
              "ngaf-8026-industry-leading-performance-with-advanced-malware-protection.pdf",
            downName:
              "ngaf-8026-industry-leading-performance-with-advanced-malware-protection.pdf",
            fileType: "pdf",
          },
          {
            id: 7,
            fileName: "ransomware-protection-best-practices.pdf",
            fileUrl: "ransomware-protection-best-practices.pdf",
            downName: "ransomware-protection-best-practices.pdf",
            fileType: "pdf",
          },
          {
            id: 8,
            fileName: "why-fighting-ransomware-is-an-uphill-battle.pdf",
            fileUrl: "why-fighting-ransomware-is-an-uphill-battle.pdf",
            downName: "why-fighting-ransomware-is-an-uphill-battle.pdf",
            fileType: "pdf",
          },
          {
            id: 9,
            fileName: "worried-about-ransomware-take-immediate-action-now.pdf",
            fileUrl: "worried-about-ransomware-take-immediate-action-now.pdf",
            downName: "worried-about-ransomware-take-immediate-action-now.pdf",
            fileType: "pdf",
          },
        ],
        2: [
          {
            id: 1,
            fileName: "Ransomware Protection Best Practices.pdf",
            fileUrl: "Ransomware Protection Best Practices.pdf",
            downName: "Ransomware Protection Best Practices.pdf",
            fileType: "pdf",
          },
          {
            id: 2,
            fileName: "Ransomware Response Playbook.pdf",
            fileUrl: "Ransomware Response Playbook.pdf",
            downName: "Ransomware Response Playbook.pdf",
            fileType: "pdf",
          },
          {
            id: 3,
            fileName: "Sangfor’s Answer to Ransomware .pdf",
            fileUrl: "Sangfor’s Answer to Ransomware .pdf",
            downName: "Sangfor’s Answer to Ransomware .pdf" ,
            fileType: "pdf",
          },
          {
            id: 4,
            fileName: "Security Solution-20200218.pdf",
            fileUrl: "Security Solution-20200218.pdf",
            downName: "Security Solution-20200218.pdf",
            fileType: "pdf",
          },
        ],
        3: [
          {
            id: 1,
            fileName:
              "[Sangfor Webinar] Unlocking New Business Opportunities with Sangfor Incident Response.pptx",
            fileUrl:
              "[Sangfor Webinar] Unlocking New Business Opportunities with Sangfor Incident Response.pptx",
            downName:
              "[Sangfor Webinar] Unlocking New Business Opportunities with Sangfor Incident Response.pptx",
            fileType: "pptx",
          },
          {
            id: 2,
            fileName:
              "[Security Webinar] A Glimpse of Ransomware Resurgence.pptx",
            fileUrl:
              "[Security Webinar] A Glimpse of Ransomware Resurgence.pptx",
            downName:
              "[Security Webinar] A Glimpse of Ransomware Resurgence.pptx",
            fileType: "pptx",
          },
          {
            id: 3,
            fileName:
              "[Security Webinar] Uncovering Telltale Signs of Ransomware with Continuous Threat Detection.pptx",
            fileUrl:
              "[Security Webinar] Uncovering Telltale Signs of Ransomware with Continuous Threat Detection.pptx",
            downName:
              "[Security Webinar] Uncovering Telltale Signs of Ransomware with Continuous Threat Detection.pptx",
            fileType: "pptx",
          },
          {
            id: 4,
            fileName:
              "Are You Doing it Right Handling A Malware Outbreak_20200921.pptx",
            fileUrl:
              "Are You Doing it Right Handling A Malware Outbreak_20200921.pptx",
            downName:
              "Are You Doing it Right Handling A Malware Outbreak_20200921.pptx",
            fileType: "pptx",
          },
          {
            id: 5,
            fileName: "Attacking the Ransomware Kill Chain.pptx",
            fileUrl: "Attacking the Ransomware Kill Chain.pptx",
            downName: "Attacking the Ransomware Kill Chain.pptx",
            fileType: "pptx",
          },
          {
            id: 6,
            fileName: "Colonial Pipeline Ransomware Attack v1.pptx",
            fileUrl: "Colonial Pipeline Ransomware Attack v1.pptx",
            downName: "Colonial Pipeline Ransomware Attack v1.pptx",
            fileType: "pptx",
          },
          {
            id: 7,
            fileName: "Hacking Made Simple With Ransomware-as-a-Service.pptx",
            fileUrl: "Hacking Made Simple With Ransomware-as-a-Service.pptx",
            downName: "Hacking Made Simple With Ransomware-as-a-Service.pptx",
            fileType: "pptx",
          },
        ],
        4: [
          {
            id: 1,
            fileName:
              "[Sangfor Webinar] Avoiding Malware Reinfection - Finding Asymptomatic Infection & Patient Zero.pdf",
            fileUrl:
              "[Sangfor Webinar] Avoiding Malware Reinfection - Finding Asymptomatic Infection & Patient Zero.pdf",
            downName:
              "[Sangfor Webinar] Avoiding Malware Reinfection - Finding Asymptomatic Infection & Patient Zero.pdf",
            fileType: "pdf",
          },
          {
            id: 2,
            fileName:
              "[Sangfor Webinar] Fighting AI-powered Cyberattacks with AI-enabled Cyber Defense.pdf",
            fileUrl:
              "[Sangfor Webinar] Fighting AI-powered Cyberattacks with AI-enabled Cyber Defense.pdf",
            downName:
              "[Sangfor Webinar] Fighting AI-powered Cyberattacks with AI-enabled Cyber Defense.pdf",
            fileType: "pdf",
          },
          {
            id: 3,
            fileName:
              "[Sangfor Webinar] Uncovering Telltale Signs of Ransomware with Continuous Threat Detection.pdf",
            fileUrl:
              "[Sangfor Webinar] Uncovering Telltale Signs of Ransomware with Continuous Threat Detection.pdf",
            downName:
              "[Sangfor Webinar] Uncovering Telltale Signs of Ransomware with Continuous Threat Detection.pdf",
            fileType: "pdf",
          },
          {
            id: 4,
            fileName:
              "certain-security-in-uncertain-times-sangfor-cyber-command.pdf",
            fileUrl:
              "certain-security-in-uncertain-times-sangfor-cyber-command.pdf",
            downName:
              "certain-security-in-uncertain-times-sangfor-cyber-command.pdf",
            fileType: "pdf",
          },
        ],
        5: [
          {
            id: 1,
            fileName:
              "Cyber Command_BR_P_Product-Introduction_20200323 (1).pdf",
            fileUrl: "Cyber Command_BR_P_Product-Introduction_20200323 (1).pdf",
            downName:
              "Cyber Command_BR_P_Product-Introduction_20200323 (1).pdf",
            fileType: "pdf",
          },
          {
            id: 2,
            fileName: "Sangfor TIARA and MDR Brochure.pdf",
            fileUrl: "Sangfor TIARA and MDR Brochure.pdf",
            downName: "Sangfor TIARA and MDR Brochure.pdf",
            fileType: "pdf",
          },
        ],
        6: [
          {
            id: 1,
            fileName:
              "[Security Webinar]  Avoiding Malware Reinfection - Finding Asymptomatic Infection & Patient Zero_2021_06_01 .pptx",
            fileUrl:
              "[Security Webinar]  Avoiding Malware Reinfection - Finding Asymptomatic Infection & Patient Zero_2021_06_01 .pptx",
            downName:
              "[Security Webinar]  Avoiding Malware Reinfection - Finding Asymptomatic Infection & Patient Zero_2021_06_01 .pptx",
            fileType: "pptx",
          },
          {
            id: 2,
            fileName:
              "[Security Webinar] Uncovering Ransomware Telltale Signs with Continuous Threat Detection.pptx",
            fileUrl:
              "[Security Webinar] Uncovering Ransomware Telltale Signs with Continuous Threat Detection.pptx",
            downName:
              "[Security Webinar] Uncovering Ransomware Telltale Signs with Continuous Threat Detection.pptx",
            fileType: "pptx",
          },
          {
            id: 3,
            fileName:
              "Fighting AI-Powered Cyberattacks with AI-Enabled Cyber Defense.pptx",
            fileUrl:
              "Fighting AI-Powered Cyberattacks with AI-Enabled Cyber Defense.pptx",
            downName:
              "Fighting AI-Powered Cyberattacks with AI-Enabled Cyber Defense.pptx",
            fileType: "pptx",
          },
          {
            id: 4,
            fileName:
              "NDR_PP_P_The Key Tool Avoiding Security Breaches_20201208 R1.pptx",
            fileUrl:
              "NDR_PP_P_The Key Tool Avoiding Security Breaches_20201208 R1.pptx",
            downName:
              "NDR_PP_P_The Key Tool Avoiding Security Breaches_20201208 R1.pptx",
            fileType: "pptx",
          },
          {
            id: 5,
            fileName:
              "Reduce Dwell Time - The Key to Fighting off Cyber-Attacks​.pptx",
            fileUrl:
              "Reduce Dwell Time - The Key to Fighting off Cyber-Attacks​.pptx",
            downName:
              "Reduce Dwell Time - The Key to Fighting off Cyber-Attacks​.pptx",
            fileType: "pptx",
          },
        ],
        7: [
          {
            id: 1,
            fileName:
              "[Sangfor Webinar] _Securing Your Internet Gateway is Vital for Security Posture.pdf",
            fileUrl:
              "[Sangfor Webinar] _Securing Your Internet Gateway is Vital for Security Posture.pdf",
            downName:
              "[Sangfor Webinar] _Securing Your Internet Gateway is Vital for Security Posture.pdf",
            fileType: "pdf",
          },
          {
            id: 2,
            fileName:
              "[Sangfor Webinar] Continuous Asset Monitoring to Accelerate Remediation.pdf",
            fileUrl:
              "[Sangfor Webinar] Continuous Asset Monitoring to Accelerate Remediation.pdf",
            downName:
              "[Sangfor Webinar] Continuous Asset Monitoring to Accelerate Remediation.pdf",
            fileType: "pdf",
          },
          {
            id: 3,
            fileName:
              "[Sangfor Webinar] Lesson Learned From Data Breaches and Ways to Better Protect Yourself.pdf",
            fileUrl:
              "[Sangfor Webinar] Lesson Learned From Data Breaches and Ways to Better Protect Yourself.pdf",
            downName:
              "[Sangfor Webinar] Lesson Learned From Data Breaches and Ways to Better Protect Yourself.pdf",
            fileType: "pdf",
          },
          {
            id: 4,
            fileName:
              "[Sangfor Webinar] Stop Panicking and Love SSL_ Decryption with Augmenting Audit_.pdf",
            fileUrl:
              "[Sangfor Webinar] Stop Panicking and Love SSL_ Decryption with Augmenting Audit_.pdf",
            downName:
              "[Sangfor Webinar] Stop Panicking and Love SSL_ Decryption with Augmenting Audit_.pdf",
            fileType: "pdf",
          },
          {
            id: 5,
            fileName:
              "[Sangfor Webinar] Trifecta Effect_ Identification, Assessment and Enforcement for Asset Management.pdf",
            fileUrl:
              "[Sangfor Webinar] Trifecta Effect_ Identification, Assessment and Enforcement for Asset Management.pdf",
            downName:
              "[Sangfor Webinar] Trifecta Effect_ Identification, Assessment and Enforcement for Asset Management.pdf",
            fileType: "pdf",
          },
        ],
        8: [
          {
            id: 1,
            fileName: "IAG Call guide_v2.pdf",
            fileUrl: "IAG Call guide_v2.pdf",
            downName: "IAG Call guide_v2.pdf",
            fileType: "pdf",
          },
          {
            id: 2,
            fileName: "IAG_BR_P_IAG-Brochure_20210601.pdf",
            fileUrl: "IAG_BR_P_IAG-Brochure_20210601.pdf",
            downName: "IAG_BR_P_IAG-Brochure_20210601.pdf",
            fileType: "pdf",
          },
        ],
        9: [
          {
            id: 1,
            fileName:
              "[Security Webinar] Lessons Learned From Data Breaches to Better Protect Yourself_20210615.pptx",
            fileUrl:
              "[Security Webinar] Lessons Learned From Data Breaches to Better Protect Yourself_20210615.pptx",
            downName:
              "[Security Webinar] Lessons Learned From Data Breaches to Better Protect Yourself_20210615.pptx",
            fileType: "pptx",
          },
          {
            id: 2,
            fileName:
              "[Webinar] Security_PP_P_Trifecta_Effect_Asset_Management_20210514.pptx",
            fileUrl:
              "[Webinar] Security_PP_P_Trifecta_Effect_Asset_Management_20210514.pptx",
            downName:
              "[Webinar] Security_PP_P_Trifecta_Effect_Asset_Management_20210514.pptx",
            fileType: "pptx",
          },
          {
            id: 3,
            fileName:
              "A Secure Internet   Gateway is Vital for Your Security Posture  .pptx",
            fileUrl:
              "A Secure Internet   Gateway is Vital for Your Security Posture  .pptx",
            downName:
              "A Secure Internet   Gateway is Vital for Your Security Posture  .pptx",
            fileType: "pptx",
          },
          {
            id: 4,
            fileName:
              "Continuous_Asset_Monitoring_to_Accelerate_RemediationV3.pptx",
            fileUrl:
              "Continuous_Asset_Monitoring_to_Accelerate_RemediationV3.pptx",
            downName:
              "Continuous_Asset_Monitoring_to_Accelerate_RemediationV3.pptx",
            fileType: "pptx",
          },
          {
            id: 5,
            fileName:
              "Stop Panicking   and Love SSL Decryption   with Augmenting Audit.pptx",
            fileUrl:
              "Stop Panicking   and Love SSL Decryption   with Augmenting Audit.pptx",
            downName:
              "Stop Panicking   and Love SSL Decryption   with Augmenting Audit.pptx",
            fileType: "pptx",
          },
        ],
        10: [
          {
            id: 1,
            fileName:
              "[Sangfor Webinar] 3 Critical Steps in Your Distributed Enterprise Protection Strategy.pdf",
            fileUrl:
              "[Sangfor Webinar] 3 Critical Steps in Your Distributed Enterprise Protection Strategy.pdf",
            downName:
              "[Sangfor Webinar] 3 Critical Steps in Your Distributed Enterprise Protection Strategy.pdf",
            fileType: "pdf",
          },
          {
            id: 2,
            fileName:
              "[Webinar] Driving Superior Business Outcomes During Covid-19 with Sangfor SD-WAN.pdf",
            fileUrl:
              "[Webinar] Driving Superior Business Outcomes During Covid-19 with Sangfor SD-WAN.pdf",
            downName:
              "[Webinar] Driving Superior Business Outcomes During Covid-19 with Sangfor SD-WAN.pdf",
            fileType: "pdf",
          },
          {
            id: 3,
            fileName:
              "smooth-steady-video-conferencing-with-sangfor-sd-wan.pdf",
            fileUrl: "smooth-steady-video-conferencing-with-sangfor-sd-wan.pdf",
            downName:
              "smooth-steady-video-conferencing-with-sangfor-sd-wan.pdf",
            fileType: "pdf",
          },
        ],
        11: [
          {
            id: 1,
            fileName:
              "SD-WAN_BR_P_Sangfor SD-WAN Best Practice for Sales_20210312.pdf",
            fileUrl:
              "SD-WAN_BR_P_Sangfor SD-WAN Best Practice for Sales_20210312.pdf",
            downName:
              "SD-WAN_BR_P_Sangfor SD-WAN Best Practice for Sales_20210312.pdf",
            fileType: "pdf",
          },
        ],
        12: [
          {
            id: 1,
            fileName:
              "[Security Webinar] 3 Critical Steps in Your Distributed Enterprise Protection Strategy_29_06_2021.pptx",
            fileUrl:
              "[Security Webinar] 3 Critical Steps in Your Distributed Enterprise Protection Strategy_29_06_2021.pptx",
            downName:
              "[Security Webinar] 3 Critical Steps in Your Distributed Enterprise Protection Strategy_29_06_2021.pptx",
            fileType: "pptx",
          },
          {
            id: 2,
            fileName:
              "Driving Superior Business Outcomes Against Covid19 with Sangfor SDWAN.pptx",
            fileUrl:
              "Driving Superior Business Outcomes Against Covid19 with Sangfor SDWAN.pptx",
            downName:
              "Driving Superior Business Outcomes Against Covid19 with Sangfor SDWAN.pptx",
            fileType: "pptx",
          },
          {
            id: 3,
            fileName: "Sangfor One-Stop SD-WAN Solution-20210226.pptx",
            fileUrl: "Sangfor One-Stop SD-WAN Solution-20210226.pptx",
            downName: "Sangfor One-Stop SD-WAN Solution-20210226.pptx",
            fileType: "pptx",
          },
          {
            id: 4,
            fileName: "SDWAN_PP_P_Sangfor Secured SDWAN_20201109 (1).pptx",
            fileUrl: "SDWAN_PP_P_Sangfor Secured SDWAN_20201109 (1).pptx",
            downName: "SDWAN_PP_P_Sangfor Secured SDWAN_20201109 (1).pptx",
            fileType: "pptx",
          },
        ],
        13: [
          {
            id: 1,
            fileName:
              "[Sangfor Webinar] Work from Home_ Staying Safe and Away from Cyber Threats.pdf",
            fileUrl:
              "[Sangfor Webinar] Work from Home_ Staying Safe and Away from Cyber Threats.pdf",
            downName:
              "[Sangfor Webinar] Work from Home_ Staying Safe and Away from Cyber Threats.pdf",
            fileType: "pdf",
          },
          {
            id: 2,
            fileName:
              "3-safety-tips-on-empowering-your-employees-to-work-from-home-securely-during-the-covid-19-pandemic.pdf",
            fileUrl:
              "3-safety-tips-on-empowering-your-employees-to-work-from-home-securely-during-the-covid-19-pandemic.pdf",
            downName:
              "3-safety-tips-on-empowering-your-employees-to-work-from-home-securely-during-the-covid-19-pandemic.pdf",
            fileType: "pdf",
          },
          {
            id: 3,
            fileName:
              "connect-secure-your-remote-employees-today-with-sangfor.pdf",
            fileUrl:
              "connect-secure-your-remote-employees-today-with-sangfor.pdf",
            downName:
              "connect-secure-your-remote-employees-today-with-sangfor.pdf",
            fileType: "pdf",
          },
          {
            id: 4,
            fileName: "sangfor-access-beyond-boundaries.pdf",
            fileUrl: "sangfor-access-beyond-boundaries.pdf",
            downName: "sangfor-access-beyond-boundaries.pdf",
            fileType: "pdf",
          },
          {
            id: 5,
            fileName: "Work From Home Solutions _ Sangfor Technologies.pdf",
            fileUrl: "Work From Home Solutions _ Sangfor Technologies.pdf",
            downName: "Work From Home Solutions _ Sangfor Technologies.pdf",
            fileType: "pdf",
          },
        ],
        14: [],
        15: [
          {
            id: 1,
            fileName:
              "[Security Webinar] US Supreme Court Drives Need for ZTNA.pptx",
            fileUrl:
              "[Security Webinar] US Supreme Court Drives Need for ZTNA.pptx",
            downName:
              "[Security Webinar] US Supreme Court Drives Need for ZTNA.pptx",
            fileType: "pptx",
          },
          {
            id: 2,
            fileName:
              "[Security Webinar] Work from Home Staying Safe and Away from Cyber Threats_Rev1_20210819.pptx",
            fileUrl:
              "[Security Webinar] Work from Home Staying Safe and Away from Cyber Threats_Rev1_20210819.pptx",
            downName:
              "[Security Webinar] Work from Home Staying Safe and Away from Cyber Threats_Rev1_20210819.pptx",
            fileType: "pptx",
          },
          {
            id: 3,
            fileName: "Minimize Cyber Security Risks for Remote Workers.pptx",
            fileUrl: "Minimize Cyber Security Risks for Remote Workers.pptx",
            downName: "Minimize Cyber Security Risks for Remote Workers.pptx",
            fileType: "pptx",
          },
        ],
      },
      fileImg: {
        ppt: require("../../../assets/img/ppt.png"),
        doc: require("../../../assets/img/doc.png"),
        pdf: require("../../../assets/img/pdf.png"),
      },
    };
  },
  methods: {
    //点击三级菜单显示内容
    handleNodeClick(data) {
      if (data.three_id) {
        this.mainTitle = data.label;
        this.pagination.total = this.feilIndexData[data.three_id].length;
        this.fileMainItemData = this.feilIndexData[data.three_id];
        this.pagination.data = this.feilIndexData[data.three_id];
        if (this.pagination.total > 8) {
          this.fileMainItemData = this.fileMainItemData.slice(0, 8);
        }
      }else{
        this.fileMainItemData=[]
      }
    },
    //点击翻页
    handleCurrentChange(val) {
      let sliceEnd = val * 8;
      let sliceStart = sliceEnd - 8;
      this.fileMainItemData = this.pagination.data.slice(sliceStart, sliceEnd);
    },
    //初始化渲染
    initRender() {
      if (this.feilIndexData[this.showId].length > 8) {
        this.pagination.total = this.feilIndexData[this.showId].length;
        this.pagination.data = this.feilIndexData[this.showId];
        this.fileMainItemData = this.feilIndexData[this.showId].slice(0, 8);
      } else {
        this.pagination.total = this.feilIndexData[this.showId].length;
        this.pagination.data = this.feilIndexData[this.showId];
        this.fileMainItemData = this.feilIndexData[this.showId];
      }
    },
    //初始渲染标题
    getFeilTitle(queryInfo) {
      this.feilListData.forEach((val) => {
        if (queryInfo.title == "Security") {
          let title = this.feilListData[0].children[0].children[0].label;
          this.mainTitle = title;
        } else {
          let title = this.feilListData[1].children[0].children[0].label;
          this.mainTitle = title;
        }
      });
    },
    //下载
    downFeil(item,type) {
      if(type!='video'){
        var a = document.createElement("a");
        var filename = item;
        a.href =getCurrentHost()+ item;
        a.download = filename;
        a.click();
      }else{
        window.open(item);
      } 
    },
  },
  created() {
    let queryInfo = this.$route.query;
    this.unfoldArr = queryInfo.unfoldArr.split(",").map(Number);
    this.showItem = this.$route.query.showItem;
    this.showId = this.$route.query.showId;
    this.treeTitle = this.$route.query.title;
    this.processEnvUrl = getCurrentHost();
    this.getFeilTitle(queryInfo)
  },
  mounted() {
    this.initRender();
    this.$nextTick(() => {
      this.$refs.tree.setCurrentKey(this.showItem);
    });
  },
};
</script>

<style scoped lang="scss">
.marketingResourses {
  width: 100%;
  padding: 5px 17px;
  border-radius: 6px;
  display: flex;
  justify-content: space-between;
  .feil_menu {
    width: 20%;
    background: #1688e1;
    .feil_menu_title {
      width: 100%;
      padding: 15px 0;
      font-size: 16px;
      font-weight: 600;
      color: #eaf3f4;
    }
  }
  .feil_main {
    width: 79.5%;
    background: #eff6ff;
    .feil_main_title {
      width: 100%;
      height: 46px;
      background: #1688e1;
      line-height: 46px;
      font-size: 16px;
      text-align: left;
      padding: 0 40px;
      color: #eaf3f4;
    }
    .feil_main_item {
      width: 100%;
      height: 680px;
      padding: 10px;
      .feil_main_item_ul {
        width: 100%;
        .feil_main_item_li {
          padding: 10px;
          .content {
            width: 100%;
            display: flex;
            background: #fff;
            padding: 10px 20px;
            border-radius: 8px;
            justify-content: space-between;
            .content_icon {
              width: 4.5%;
              height: 42px;
              margin-right: 15px;
              background: #248fe6;
              border-radius: 4px;
              display: flex;
              align-items: center;
              justify-content: center;
              img {
                width: 100%;
              }
              .svg-icon {
                font-size: 28px;
                color: #fff;
                font-weight: 600;
              }
            }
            .content_down {
              width: 4%;
              display: flex;
              align-items: center;
              justify-content: center;
              .svg-icon {
                font-size: 24px;
                color: #248fe6;
              }
            }
            .content_title {
              width: 90%;
              display: flex;
              align-items: center;
              font-size: 14px;
              p {
                width: 100%;
                text-align: left;
                color: #248fe6;
                font-weight: 600;
              }
            }
          }
        }
      }
      .noDetail{
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        flex-direction: column;
        justify-content: center;
        .svg-icon{
          font-size: 60px;
        }
        p{
          font-size: 14px;
        }
      }
    }
  }
}
</style>